"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Textarea = require("./Textarea.Styled");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Textarea = _ref => {
  let {
    onChange: _onChange,
    value,
    placeholder,
    className,
    label,
    rows = 3,
    required = false
  } = _ref;
  if (typeof _onChange !== 'function') return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Textarea.Wrapper, null, label && /*#__PURE__*/_react.default.createElement(_Textarea.Label, null, label), /*#__PURE__*/_react.default.createElement(_Textarea.StyledTextarea, {
    onChange: e => _onChange(e.target.value),
    value: value,
    placeholder: placeholder,
    required: required,
    className: className,
    rows: rows
  }));
};

var _default = Textarea;
exports.default = _default;